import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";
import Footer from "./Footer.js";
import ArrowRight from "./ArrowRight.js";
import HoriLine from "./HoriLine.js";
import BlobLeft from "./BlobLeft.js";
import BlobRight from "./BlobRight.js";
import LinearProgress from "@mui/material/LinearProgress";
import { ThemeProvider } from '@mui/material/styles';



function ihs(f)
{
	return (window.innerHeight * f) + "px";
}

function IdeointiMob(p)
{

		return (<div style={{color: "#000000", fontSize: "100%", textAlign:"center"}}>
		<div className="keskitettymob">
			<img height={ihs(0.25)} src={window.IDEOINTITEKSTIT.ekaosiokuvamob} />
		</div>
		<div className="keskitettymob">
			<h1>{window.IDEOINTITEKSTIT.ekaosio}</h1>
			<div key="gapihmomia" className="otsikkogap"></div>
			{window.IDEOINTITEKSTIT.ekaosioekar}
			<div key="gapihmomib" className="paragap"></div>
			{window.IDEOINTITEKSTIT.ekaosiotokar}
		</div>
		<div>
		<HoriLine fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)"/>
		</div>
		<div className="keskitettymob">
			<img height={ihs(0.25)}  src={window.IDEOINTITEKSTIT.tokaosiokuva} />
		</div>
		<div key="gapihmomic" className="osiogap"></div>
		<div className="keskitettymob">
			<span style={{verticalAlign: "middle"}} >{window.IDEOINTITEKSTIT.tokaosioekar}</span>
		</div>
		<div key="gapihmomid" className="osiogap"></div>
		<div className="keskitettymob">
		<h3>{window.IDEOINTITEKSTIT.kolmasosioekar}</h3>
		</div>
		<div key="gapihmomie" className="osiogap"></div>
		<div key="gapihmomif" className="osiogap"></div>
		<div className="keskitettymob">
			<img height={ihs(0.25)} src={window.IDEOINTITEKSTIT.neljasosiokuva} />
		</div>
		<div key="gapihmomic" className="osiogap"></div>
		<div></div>
		<div className="keskitettymob">
			{window.IDEOINTITEKSTIT.neljasosioekar}
			<div key="gapihmomih" className="paragap"></div>
			<h3>{window.IDEOINTITEKSTIT.neljasosiotokar}</h3>
		</div>
		<div key="gapihmomii" className="osiogap"></div>
		<div className="keskitettymob">
		{window.IDEOINTITEKSTIT.viidesosioekar}
		</div>
		<div style={{textAlign: "left", marginLeft:"5%", marginRight:"5%"}}>
			<ul style={{listStyleImage: "url('"+window.IDEOINTITEKSTIT.viidesosiobullet+"')"}}>
				<li>{window.IDEOINTITEKSTIT.viidesosioekap}</li>
				<li>{window.IDEOINTITEKSTIT.viidesosiotokap}</li>
				<li>{window.IDEOINTITEKSTIT.viidesosiokolmasp}</li>
			</ul>
		</div>
		<div key="gapihmomiz"></div>

		<div key="gapihmomiq" className="osiogap"></div>
		<div className="keskitettymob">
		{window.IDEOINTITEKSTIT.kuudesosioekar}
		</div>
		<div key="gapihmomiaa" className="otsikkogap"></div>
		<div className="keskitettymob">
		{window.IDEOINTITEKSTIT.kuudesosiotokar}
		</div>
		<div key="gapihmomiab" className="otsikkogap"></div>
		<div key="gapihmomipq" className="osiogap"></div>
		<div className="seuraavasivumob">
			<div className="seuraavasivuotsikko" style={{transform: "scale(0.5)"}}>
				<Link to="../jalostus" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToJalostusMob} >
					<span style={{color: "#000000", fontSize:"2em", fontWeight:"bold", verticalAlign: "middle"}}>JALOSTUS</span>
				</Link>
			</div>
			<div style={{transform: "scale(0.75)"}}>
				<Link to="../jalostus" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToJalostusMob} >
					<ArrowRight  stroke="#000000"/>
				</Link>
			</div>
		</div>

		</div>);
}
function moveToJalostusMob()
{
	window.SETJALOSTUS();
	window.drawJalostus();
}




export default IdeointiMob;
